export default "__VITE_ASSET__BpbKRNn4__"